import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-pytorch',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>PyTorch icon</title><path d="M12.005 0L4.952 7.053a9.865 9.865 0 000 14.022 9.866 9.866 0 0014.022 0c3.984-3.9 3.986-10.205.085-14.023l-1.744 1.743c2.904 2.905 2.904 7.634 0 10.538s-7.634 2.904-10.538 0-2.904-7.634 0-10.538l4.647-4.646.582-.665zm3.568 3.899a1.327 1.327 0 00-1.327 1.327 1.327 1.327 0 001.327 1.328A1.327 1.327 0 0016.9 5.226 1.327 1.327 0 0015.573 3.9z"/></svg>`,
    styles: []
})
export class SimpleIconsPytorchComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#EE4C2C';
    @Input() className: string = 'simple-icons-pytorch'
    constructor() {}
    ngOnInit(): void {}
}
